'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ELEMENT_MOVE = exports.ELEMENT_MOVE = 'ELEMENT_MOVE';
var ELEMENT_CREATE = exports.ELEMENT_CREATE = 'ELEMENT_CREATE';
var ELEMENT_DELETE = exports.ELEMENT_DELETE = 'ELEMENT_DELETE';
var ELEMENT_UPDATE = exports.ELEMENT_UPDATE = 'ELEMENT_UPDATE';
var ELEMENT_SET_TYPE = exports.ELEMENT_SET_TYPE = 'ELEMENT_SET_TYPE';
var ELEMENT_SHARE = exports.ELEMENT_SHARE = 'ELEMENT_SHARE';
var ELEMENT_UNSHARE = exports.ELEMENT_UNSHARE = 'ELEMENT_UNSHARE';
var ELEMENT_MOVE_AND_UPDATE = exports.ELEMENT_MOVE_AND_UPDATE = 'ELEMENT_MOVE_AND_UPDATE';

var ELEMENT_MOVE_MULTI = exports.ELEMENT_MOVE_MULTI = 'ELEMENT_MOVE_MULTI';

// Server interactions
var ELEMENT_FORCE_LOAD = exports.ELEMENT_FORCE_LOAD = 'ELEMENT_FORCE_LOAD';

// Attachments
var ELEMENT_ATTACHMENT_UPLOADING = exports.ELEMENT_ATTACHMENT_UPLOADING = 'ELEMENT_ATTACHMENT_UPLOADING';
var ELEMENT_ATTACHMENT_DATA_READY = exports.ELEMENT_ATTACHMENT_DATA_READY = 'ELEMENT_ATTACHMENT_DATA_READY';
var ELEMENT_ATTACHMENT_UPLOAD_PROGRESSED = exports.ELEMENT_ATTACHMENT_UPLOAD_PROGRESSED = 'ELEMENT_ATTACHMENT_UPLOAD_PROGRESSED';
var ELEMENT_ATTACHMENT_UPLOAD_COMPLETED = exports.ELEMENT_ATTACHMENT_UPLOAD_COMPLETED = 'ELEMENT_ATTACHMENT_UPLOAD_COMPLETED';
var ELEMENT_ATTACHMENT_CLEAN = exports.ELEMENT_ATTACHMENT_CLEAN = 'ELEMENT_ATTACHMENT_CLEAN';
var ELEMENT_ATTACHMENT_UPLOAD_ERROR = exports.ELEMENT_ATTACHMENT_UPLOAD_ERROR = 'ELEMENT_ATTACHMENT_UPLOAD_ERROR';
var ELEMENT_ATTACHMENT_CLEAR_ERROR = exports.ELEMENT_ATTACHMENT_CLEAR_ERROR = 'ELEMENT_ATTACHMENT_CLEAR_ERROR';

// Icons
var ELEMENT_ICON_FIND = exports.ELEMENT_ICON_FIND = 'ELEMENT_ICON_FIND';
var ELEMENT_ICON_FIND_SUCCESS = exports.ELEMENT_ICON_FIND_SUCCESS = 'ELEMENT_ICON_FIND_SUCCESS';
var ELEMENT_ICON_FIND_FAILURE = exports.ELEMENT_ICON_FIND_FAILURE = 'ELEMENT_ICON_FIND_FAILURE';
var ELEMENT_ICON_SEARCH = exports.ELEMENT_ICON_SEARCH = 'ELEMENT_ICON_SEARCH';

var ELEMENT_DND_TYPE = exports.ELEMENT_DND_TYPE = 'ELEMENT';

var SKELETON_ELEMENT_TYPE = exports.SKELETON_ELEMENT_TYPE = 'SKELETON';

var DROP_TARGET_BEHAVIOUR = exports.DROP_TARGET_BEHAVIOUR = {
    SHRINK: 'shrink',
    SHRINK_LIST: 'shrink-list',
    NONE: null
};

var DROP_TARGET_TYPES = exports.DROP_TARGET_TYPES = {
    BOARD: DROP_TARGET_BEHAVIOUR.SHRINK,
    TRASH: DROP_TARGET_BEHAVIOUR.SHRINK,
    BREADCRUMB: DROP_TARGET_BEHAVIOUR.SHRINK,
    INBOX_CLOSED: DROP_TARGET_BEHAVIOUR.SHRINK,
    LIST: DROP_TARGET_BEHAVIOUR.SHRINK_LIST,
    NONE: DROP_TARGET_BEHAVIOUR.NONE
};

var ELEMENT_DEFAULT_WIDTH = exports.ELEMENT_DEFAULT_WIDTH = 34;


//////////////////
// WEBPACK FOOTER
// ./src/common/elements/elementConstants.js
// module id = 12
// module chunks = 0